export const formData = {
    currentStep: 'pageOne',
    formState: {}
};

export const saveToLocalStorage = (data) => {
    const existing = JSON.parse(localStorage.getItem('formData') || '{}');
    const merged = { ...existing, ...data };
    localStorage.setItem('formData', JSON.stringify(merged));
    return merged;
};

export const loadFromLocalStorage = () => {
    return JSON.parse(localStorage.getItem('formData') || '{}');
};

export const getCurrentStep = () => {
    return localStorage.getItem('currentStep') || 'pageOne';
};

export const saveAllData = (data) => {
    const existing = loadFromLocalStorage();
    const merged = { ...existing, ...data };
    localStorage.setItem('formData', JSON.stringify(merged));
};

export const clearLocalStorage = () => {
    localStorage.removeItem('formData');
    localStorage.removeItem('currentStep');
}; 